module.exports = __webpack_public_path__ + "img/maskexbanner.d69dad35.png";